import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import Image from "@/components/Image";
import { getGrocery } from "@/services";
import formatTime from "@/utils/formatTime";
import { useMount, useSafeState } from "ahooks";
import { Button } from "antd";
import classNames from "classnames";
import { uniqBy } from "lodash";
import { useMemo } from "react";
import { When } from "react-if";
import InfoCard from "../shared/infoCard";
import Tip from "../shared/tip";
import styles from "./index.module.less";
/**
 * @param {{
 *    order: Object,
 *    title: string,
 *    onNext: (Object)=>void
 *    show?: boolean
 *    bottom?: React.ReactNode
 * } & import("react").HTMLAttributes } props
 * @returns
 */
// 换购商品类型
const REDEEM_CODE = "redeem_code";
const initIcon =
  "https://cdn.dancf.com/fe-assets/20231104/4001e25dc48c6efa6f6fed8da9c8885e.jpg";
export default function PayResult({
  order = { skus: [] },
  title = "恭喜你加入花瓣素材VIP",
  show = true,
  bottom,
  onNext,
  ...props
} = {}) {
  const [upgradedPurchase, setUpgradedPurchase] = useSafeState();

  const onCopy = (content) => {
    navigator.clipboard.writeText(content);
    HBMessage.success("兑换码复制成功");
  };
  // 去重合并计数
  const skus = useMemo(() => {
    // 去重
    const dedup = uniqBy(order.skus, "ref_code");
    // 计数
    dedup.forEach((item) => {
      item.number = order.skus.filter(
        ({ ref_code }) => ref_code === item.ref_code
      ).length;
    });

    return dedup;
  }, [order]);
  useMount(async () => {
    const data = await getGrocery("vip-buydialog");
    setUpgradedPurchase(data.upgradedPurchase);
  });

  return (
    <div className={styles.info} {...props}>
      <h1 className={styles.title}>
        <Welcome title={title} />
      </h1>
      <InfoCard styles={{ marginBottom: 32 }} className={styles.card}>
        <InfoCard.Item
          label="商品名称"
          value={skus.map((sku, index) => {
            // 找到对应的杂货铺配置(杂货铺的code 支持 商品code/SkuId两种方式，所以我们需要两种方式都尝试下)
            // 方式一直接匹配sku.ref_code
            // 方式二匹配ref_body.goods.code + '.' + ref_body.custom_code
            let target = upgradedPurchase?.goods?.find(
              (item) =>
                item.code === sku?.ref_code ||
                item.code ===
                  `${sku?.ref_code?.goods?.code}.${sku?.ref_code?.custom_code}`
            );
            // 找到对应的兑换码
            const exchangeCode = order?.redeem_codes?.find(
              (item) =>
                item?.activity?.code === sku?.ref_body?.redeem_activity_code
            )?.code;

            return (
              <div className={classNames(styles.skuTitle)} key={sku.ref_code}>
                <img
                  src={sku?.ref_body?.goods?.images?.[0]?.url || initIcon}
                  alt=""
                  width={18}
                />

                {sku?.ref_body?.name}
                {sku.number > 1 ? `(${sku.number}个)` : ""}
                <When
                  condition={
                    sku?.ref_body?.goods?.type === REDEEM_CODE && exchangeCode
                  }
                >
                  <span>（兑换码：{exchangeCode}</span>
                  <HBIcon
                    className={styles.copy}
                    type="copy"
                    onClick={() => onCopy(exchangeCode)}
                  />
                  <a
                    href={target?.exchangeHref}
                    className={styles.link}
                    target="_blank"
                    rel="noreferrer"
                    data-gd-click="button_click"
                    data-button-name="跳转兑换页面"
                  >
                    去兑换
                  </a>
                  <span>）</span>
                </When>
              </div>
            );
          })}
        />
        <InfoCard.Item label="订单编号" value={order.order_no} />
        <InfoCard.Item
          label="下单时间"
          value={formatTime(order.payment_time)}
        />
        <InfoCard.Item
          label="订单金额"
          value={"￥" + order.amount}
          valueStyle={{ color: "#FF5967" }}
        />
      </InfoCard>
      {show && (
        <>
          <Tip
            message="下载前请务必填写授权书，否则无法获取商用保障权益"
            style={{ marginTop: 16, marginBottom: 24 }}
            className={styles.tipMessage}
          />
          <div style={{ textAlign: "center" }}>
            <Button size="large" type="primary" onClick={onNext}>
              去填写授权书
            </Button>
          </div>
        </>
      )}
      {bottom}
    </div>
  );
}

function Welcome({ title = "恭喜你加入花瓣素材VIP" }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Image
        width={200}
        src={"https://st0.dancf.com/static/02/202203170446-6cb7.svg"}
        alt="花瓣素材VIP"
        style={{ marginBottom: 40 }}
      />
      <span>{title}</span>
    </div>
  );
}
